module.exports = __webpack_public_path__ + "img/open_mode2.0facac9e.jpg";